import Header from '../../src-utilities/header';
import './../../src-utilities/footer';
import './newsLetter.scss';
import '../../src-utilities/cta';
import JustValidate from './../../../node_modules/just-validate';
import Swal from '../../../node_modules/sweetalert2';
import Swiper from 'swiper';
import {
	Navigation,
	Keyboard,
	Autoplay,
	Pagination,
	Mousewheel,
	Scrollbar,
} from 'swiper/modules';
import '../../src-utilities/subscribe';

new Header();

let tabs = document.getElementsByClassName('tabs');
for (let index = 0; index < tabs.length; index++) {
	const tabs_element = tabs[index];
	tabs_element.addEventListener('click', function (e) {
		const target = e.currentTarget;
		const select_active = document.querySelector('.tabs.active');
		select_active.classList.remove('active');
		target.classList.add('active');

		let cards_ative = document.querySelector('.cards.active');
		cards_ative.classList.remove('active');
		let add_active = document.querySelector(
			".cards[data-attr='" + target.getAttribute('data-attr') + "']",
		);
		add_active.classList.add('active');
	});
}

new Swiper('.swiper-container', {
	loop: true,
	modules: [Scrollbar, Mousewheel, Autoplay, Pagination],
	loopAdditionalSlides: 1,
	centeredSlides: true,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
	autoplay: true,
	slidesPerView: 1,
	spaceBetween: 0,
	breakpoints: {
		768: {
			spaceBetween: 0,
		},
	},
});

let mobile_tabs_active = document.querySelectorAll('.mobile_tabs.active')[0];
mobile_tabs_active.addEventListener('click', function (e) {
	let target = e.currentTarget;
	if (target.parentNode.classList.contains('active')) {
		target.parentNode.classList.remove('active');
	} else {
		target.parentNode.classList.add('active');
	}
});

let mobile_tabs = document.getElementsByClassName('mobile_tabs');
for (let index = 0; index < mobile_tabs.length; index++) {
	const mobile_tabs_element = mobile_tabs[index];
	mobile_tabs_element.addEventListener('click', function (e) {
		if (e.currentTarget.classList.contains('active') == false) {
			let get_data = e.currentTarget.getAttribute('data-attr');
			let old_text = mobile_tabs_active.children[0].innerText;
			mobile_tabs_active.children[0].innerText =
				e.currentTarget.innerText;
			e.currentTarget.innerText = old_text;
			e.currentTarget.setAttribute('data-attr', old_text);

			//find div and show data of id
			let cards_ative = document.querySelector('.cards.active');
			cards_ative.classList.remove('active');
			let add_active = document.querySelector(
				".cards[data-attr='" + get_data + "']",
			);

			add_active.classList.add('active');
			document
				.querySelector('.mobilenav-tabs.active')
				.classList.remove('active');
		}
	});
}

//#region Success Form

document
	.querySelector('.register-now')
	.addEventListener('click', openSuccessForm);

document
	.querySelector('#success-form .close-button svg')
	.addEventListener('click', closeSuccessForm);

document.querySelector('#success-form').addEventListener('click', (e) => {
	if (e.target.classList.contains('form-overlay')) {
		closeSuccessForm();
	}
});

window.addEventListener('keyup', (e) => {
	if (e.key === 'Escape') {
		closeSuccessForm();
	}
});

function openSuccessForm() {
	document.querySelector('#success-form').classList.add('open');
	displayCaptcha();
}

function closeSuccessForm() {
	document.querySelector('#success-form').classList.remove('open');
}

const successform = document.querySelector('#successform');
const submitBtn = document.querySelector('#successform button[type="submit"]');

const validate = new JustValidate('#successform');

validate
	.addField('#success-fullname', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 2,
		},
	])
	.addField('#success-companyemail', [
		{
			rule: 'required',
		},
		{
			rule: 'email',
		},
		{
			validator: (value) => {
				let emailRegex =
					/^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
				return emailRegex.test(value);
			},
			errorMessage: 'Please Enter Valid Email Address',
		},
	]);

let GoogleSendURL =
	'https://script.google.com/macros/s/AKfycbyML8OHUDSwwvY_QcBlZ2uHYN_rQIx_VlWZPLjpxoJ9dB8GQEr6J7U0D8kNzC3-p0nH/exec';

var loading_global = document.querySelector('.loading-div');

document
	.querySelector('#successform')
	.addEventListener('submit', async (event) => {
		const dataget = validateCaptcha();
		event.preventDefault();
		if (validate.isValid == false || dataget == false) {
			return false;
		} else {
			document.getElementById('captchaError').style.display = 'none';
		}

		loading_global.classList.add('active');

		let formData = new FormData(event.target);
		let fullName = formData.get('lfirstname').split(' ');
		let firstName, lastName;
		[firstName, ...lastName] = fullName;
		lastName = lastName.join(' ');
		formData.set('lfirstname', firstName);
		formData.set('llastname', lastName);
		formData.append('sendurlvalue', window.location.href);
		formData.append('lsource', 'SS-News-Letter-Form');

		let myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');

		// Initiate the Sales IQ visitor data
		if (window.$zoho && window.$zoho.salesiq) {
			try {
				$zoho.salesiq.visitor.uniqueid();
				$zoho.salesiq.visitor.name(firstName + ' ' + lastName);
				$zoho.salesiq.visitor.email(formData.get('lemail'));
				console.log('SalesIQ Name/Email set');
			} catch (error) {
				console.warn('SalesIQ Error:', error);
			}
		}

		let raw = JSON.stringify({
			firstName: formData.get('lfirstname'),
			lastName: formData.get('llastname'),
			email: formData.get('lemail'),
			leadSource: formData.get('lsource'),
			websiteVisitURL: window.location.href,
		});

		let requestOptions = {
			method: 'POST',
			headers: myHeaders,
			body: raw,
			redirect: 'follow',
		};
		let googleRequestOptions = {
			method: 'GET',
			redirect: 'follow',
		};
		let request = '?';
		[...formData].forEach(([key, value], index) => {
			request += `${index === 0 ? '' : '&'}${key + '=' + value}`;
		});

		// Request 1: Main Backend
		const backendRequest = fetch(
			'https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp',
			requestOptions,
		);

		// Request 2: Update the Google Sheet Data
		const googleRequest = fetch(
			GoogleSendURL + request,
			googleRequestOptions,
		);

		// Waiting until these request get's completed
		try {
			await Promise.allSettled([backendRequest, googleRequest]);
		} catch (e) {
			console.error('API Error', e);
		}

		// Redirect
		window.location.href = 'https://cyntexa.com/success?msg=newsletter';
	});

//#endregion Success Form

//#region Capctha added here

// Function to generate random string CAPTCHA
function generateCaptcha(length) {
	const characters =
		'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	let captcha = '';
	for (let i = 0; i < length; i++) {
		const randomIndex = Math.floor(Math.random() * characters.length);
		captcha += characters[randomIndex];
	}
	return captcha;
}

// Function to display the CAPTCHA
function displayCaptcha() {
	const captcha = generateCaptcha(6); // Generate a 6-character CAPTCHA
	document.getElementById('captchaChallenge').innerText = captcha;
	document.getElementById('successform').dataset.captcha = captcha; // Store CAPTCHA in form's data attribute
}

// Function to validate the CAPTCHA
function validateCaptcha() {
	const userCaptcha = document.getElementById('captchaInput').value;
	const actualCaptcha =
		document.getElementById('successform').dataset.captcha;
	if (userCaptcha === actualCaptcha) {
		return true; // CAPTCHA is correct
	} else {
		document.getElementById('captchaError').style.display = 'block'; // Show error message
		displayCaptcha(); // Generate a new CAPTCHA
		return false; // Prevent form submission
	}
}

//#endregion Capctha added here

window.addEventListener('load', function () {
	if (window.location.hash.toLowerCase().includes('#subscribe')) {
		setTimeout(() => {
			openSuccessForm();
		}, 500);
	}
});
